import { useState, useEffect } from "react";
import { getOnlineStationsAPI } from "../api/stations";

// Puna lista stanica sa polascima za dati datum (i po polaznoj stanici za
// dolazne). `stations === null` znači „nedostupno" — pozivalac tada pada na
// staru serversku pretragu. Keš po (datum|polazna) traje koliko i sesija:
// ponuda stanica za dan se ne menja tokom kupovine.
const cache = new Map();

export default function useOnlineStations(journeyDate, fromStationId = null) {
    const [stations, setStations] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!journeyDate) {
            setStations(null);
            return undefined;
        }
        const key = `${journeyDate}|${fromStationId ?? ""}`;
        if (cache.has(key)) {
            setStations(cache.get(key));
            return undefined;
        }
        let alive = true;
        setLoading(true);
        getOnlineStationsAPI({ journeyDate, fromStationId })
            .then((list) => {
                cache.set(key, list);
                if (alive) setStations(list);
            })
            .catch((error) => {
                console.error("Greška pri učitavanju stanica za datum:", error);
                if (alive) setStations(null);
            })
            .finally(() => {
                if (alive) setLoading(false);
            });
        return () => {
            alive = false;
        };
    }, [journeyDate, fromStationId]);

    return { stations, loading };
}
